import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { DataPersistence } from './data-persistence';
/**
 * @whatItDoes Provides services for enterprise Angular applications.
 *
 * See {@link DataPersistence} for more information.
 */
var NxModule = /** @class */ (function () {
    function NxModule() {
    }
    NxModule_1 = NxModule;
    NxModule.forRoot = function () {
        return { ngModule: NxModule_1, providers: [DataPersistence] };
    };
    var NxModule_1;
    NxModule = NxModule_1 = tslib_1.__decorate([
        NgModule({})
    ], NxModule);
    return NxModule;
}());
export { NxModule };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibngubW9kdWxlLmpzIiwic291cmNlUm9vdCI6Im5nOi8vQG5yd2wvYW5ndWxhci8iLCJzb3VyY2VzIjpbInNyYy9ydW50aW1lL254L254Lm1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUF1QixRQUFRLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFDOUQsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLG9CQUFvQixDQUFDO0FBRXJEOzs7O0dBSUc7QUFFSDtJQUFBO0lBSUEsQ0FBQztpQkFKWSxRQUFRO0lBQ1osZ0JBQU8sR0FBZDtRQUNFLE9BQU8sRUFBRSxRQUFRLEVBQUUsVUFBUSxFQUFFLFNBQVMsRUFBRSxDQUFDLGVBQWUsQ0FBQyxFQUFFLENBQUM7SUFDOUQsQ0FBQzs7SUFIVSxRQUFRO1FBRHBCLFFBQVEsQ0FBQyxFQUFFLENBQUM7T0FDQSxRQUFRLENBSXBCO0lBQUQsZUFBQztDQUFBLEFBSkQsSUFJQztTQUpZLFFBQVEiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBNb2R1bGVXaXRoUHJvdmlkZXJzLCBOZ01vZHVsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuaW1wb3J0IHsgRGF0YVBlcnNpc3RlbmNlIH0gZnJvbSAnLi9kYXRhLXBlcnNpc3RlbmNlJztcblxuLyoqXG4gKiBAd2hhdEl0RG9lcyBQcm92aWRlcyBzZXJ2aWNlcyBmb3IgZW50ZXJwcmlzZSBBbmd1bGFyIGFwcGxpY2F0aW9ucy5cbiAqXG4gKiBTZWUge0BsaW5rIERhdGFQZXJzaXN0ZW5jZX0gZm9yIG1vcmUgaW5mb3JtYXRpb24uXG4gKi9cbkBOZ01vZHVsZSh7fSlcbmV4cG9ydCBjbGFzcyBOeE1vZHVsZSB7XG4gIHN0YXRpYyBmb3JSb290KCk6IE1vZHVsZVdpdGhQcm92aWRlcnMge1xuICAgIHJldHVybiB7IG5nTW9kdWxlOiBOeE1vZHVsZSwgcHJvdmlkZXJzOiBbRGF0YVBlcnNpc3RlbmNlXSB9O1xuICB9XG59XG4iXX0=